import { SoftwareSubscriptionStatus } from '@hdms/shared/common-types';

import { StatusNotification } from './subscription.constants';

export const statusNotificationThumbnailData: StatusNotification[] = [
  { status: SoftwareSubscriptionStatus.PENDING, qaId: 'Pending', iconColor: 'danger' },
  { status: SoftwareSubscriptionStatus.CANCELED, qaId: 'Canceled', iconColor: 'danger' },
  { status: SoftwareSubscriptionStatus.CANCELED_LEGACY, qaId: 'Canceled', iconColor: 'danger' },
  { status: SoftwareSubscriptionStatus.NOT_STARTED, qaId: 'NotStarted', iconColor: 'warning' },
  { status: SoftwareSubscriptionStatus.ACTIVE, qaId: 'Modified', iconColor: 'warning' }
];

export const statusNotificationTooltipData: StatusNotification[] = [
  {
    status: SoftwareSubscriptionStatus.PENDING,
    qaId: 'Pending',
    translation: 'softwareOverview.infoLabels.pendingSubscriptionInfo',
    iconColor: 'danger'
  },
  {
    status: SoftwareSubscriptionStatus.CANCELED,
    qaId: 'Canceled',
    translation: 'shared.labels.cancelled',
    iconColor: 'danger'
  },
  {
    status: SoftwareSubscriptionStatus.CANCELED_LEGACY,
    qaId: 'Canceled',
    translation: 'shared.labels.cancelled',
    iconColor: 'danger'
  },
  {
    status: SoftwareSubscriptionStatus.NOT_STARTED,
    qaId: 'NotStarted',
    translation: 'softwareOverview.infoLabels.notStarted',
    iconColor: 'warning'
  },
  {
    status: SoftwareSubscriptionStatus.ACTIVE,
    qaId: 'Modified',
    translation: 'softwareOverview.infoLabels.modified',
    iconColor: 'warning'
  }
];

export const pendingAmendmentStatusNotificationData: Omit<StatusNotification, 'status'> = {
  qaId: 'PendingAmendment',
  translation: 'softwareOverview.infoLabels.newAgreement',
  iconColor: 'danger'
};

export const statusNotificationSubscriptionManagementDetailsModalData: StatusNotification[] = [
  {
    status: SoftwareSubscriptionStatus.CANCELED,
    qaId: 'Canceled',
    translation: {
      heading: 'subscriptionManagement.modals.subscriptionManagementDetailsModal.subscriptionCancelled',
      description: 'subscriptionManagement.modals.subscriptionManagementDetailsModal.subscriptionCancelledInfo'
    },
    iconColor: 'danger'
  },
  {
    status: SoftwareSubscriptionStatus.CANCELED_LEGACY,
    qaId: 'Canceled',
    translation: {
      heading: 'subscriptionManagement.modals.subscriptionManagementDetailsModal.subscriptionCancelled',
      description: 'subscriptionManagement.modals.subscriptionManagementDetailsModal.subscriptionCancelledInfo'
    },
    iconColor: 'danger'
  },
  {
    status: SoftwareSubscriptionStatus.NOT_STARTED,
    qaId: 'NotStarted',
    translation: {
      heading: 'subscriptionManagement.modals.subscriptionManagementDetailsModal.subscriptionNotStarted',
      description: 'subscriptionManagement.modals.subscriptionManagementDetailsModal.subscriptionNotStartedInfo'
    },
    iconColor: 'warning'
  }
];

export const statusNotificationSubscriptiontDetailsModalData: StatusNotification[] = [
  {
    status: SoftwareSubscriptionStatus.CANCELED,
    qaId: 'Canceled',
    translation: {
      heading: 'softwareOverview.infoLabels.subscriptionCancelled',
      description: 'softwareOverview.infoLabels.subscriptionCancelledInfo'
    },
    iconColor: 'danger'
  },
  {
    status: SoftwareSubscriptionStatus.CANCELED_LEGACY,
    qaId: 'Canceled',
    translation: {
      heading: 'softwareOverview.infoLabels.subscriptionCancelled',
      description: 'softwareOverview.infoLabels.subscriptionCancelledInfo'
    },
    iconColor: 'danger'
  },
  {
    status: SoftwareSubscriptionStatus.NOT_STARTED,
    qaId: 'NotStarted',
    translation: {
      heading: 'softwareOverview.infoLabels.subscriptionNotStarted',
      description: 'softwareOverview.infoLabels.subscriptionNotStartedInfo'
    },
    iconColor: 'warning'
  }
];

export const statusNotificationSubscriptiontManageSubscriptionData: StatusNotification[] = [
  {
    status: SoftwareSubscriptionStatus.CANCELED,
    qaId: 'Canceled',
    translation: {
      heading: 'subscriptionManagement.statusBar.infoHeader',
      description: 'subscriptionManagement.statusBar.infoText'
    },
    iconColor: 'danger'
  },
  {
    status: SoftwareSubscriptionStatus.CANCELED_LEGACY,
    qaId: 'Canceled',
    translation: {
      heading: 'subscriptionManagement.statusBar.infoHeader',
      description: 'subscriptionManagement.statusBar.infoText'
    },
    iconColor: 'danger'
  },
  {
    status: SoftwareSubscriptionStatus.NOT_STARTED,
    qaId: 'NotStarted',
    translation: {
      heading: 'subscriptionManagement.modals.subscriptionManagementDetailsModal.subscriptionNotStarted',
      description: 'subscriptionManagement.modals.subscriptionManagementDetailsModal.subscriptionNotStartedInfo'
    },
    iconColor: 'warning'
  }
];
